import { object, string } from 'zod';

import { makeZodValidate as makeValidate } from '@occc-app/design-system';

const schema = object({
  name: string(),
});

export const validateLocationGroup = makeValidate(schema);
